var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6529_44782)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.7993,
    cy: 18.0039,
    r: 14,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6529_44782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1328 12.6707V20.6707C16.1328 21.0244 16.2733 21.3635 16.5233 21.6135C16.7734 21.8636 17.1125 22.0041 17.4661 22.0041H22.7995C23.1531 22.0041 23.4922 21.8636 23.7423 21.6135C23.9923 21.3635 24.1328 21.0244 24.1328 20.6707V14.8321C24.1328 14.6544 24.0973 14.4786 24.0284 14.3149C23.9594 14.1512 23.8585 14.0029 23.7315 13.8787L21.5215 11.7174C21.2724 11.4738 20.9379 11.3374 20.5895 11.3374H17.4661C17.1125 11.3374 16.7734 11.4779 16.5233 11.7279C16.2733 11.978 16.1328 12.3171 16.1328 12.6707Z",
    stroke: "#3C5F7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4658 22.0042V23.3376C21.4658 23.6912 21.3253 24.0303 21.0753 24.2804C20.8252 24.5304 20.4861 24.6709 20.1325 24.6709H14.7992C14.4455 24.6709 14.1064 24.5304 13.8563 24.2804C13.6063 24.0303 13.4658 23.6912 13.4658 23.3376V16.0042C13.4658 15.6506 13.6063 15.3115 13.8563 15.0614C14.1064 14.8114 14.4455 14.6709 14.7992 14.6709H16.1325",
    stroke: "#3C5F7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6529_44782",
    x: 0.799316,
    y: 0.00390625,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6529_44782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6529_44782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6529_44782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10.7993 10.0039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.ebde1d8822264e87ad5d68b1f66110ab.svg";
export { ForwardRef as ReactComponent };